export default {
  filtersMap: {
    names: 'Groups',
    themes: 'Themes',
    tags: 'Tags',
    polarities: 'Sentiment',
    dark_post: 'Publication Type',
    channels_listening: 'Channels',
    channels: 'Channels',
    uids: 'Authors',
    pages: 'Pages',
    sac_type: 'Interactions',
    sac_status: 'Status',
    sac_replier: 'Repliers',
    contracts: 'Contract',
    bots: 'Bot',
    category: 'Category',
    domains: 'Channels',
    operators: 'Operators',
    teams: 'Queues',
    desk_tags: 'Tags',
    scheduled: 'Campaigns',
    campaign_name: 'Campaign Name',
  },
  noRepliers: 'No repliers',
  dateRange: 'Time range',
  scheduledOnly: 'Only Scheduled',
};
